module.exports = __webpack_public_path__ + "img/chicago.b57055f5.jpg";